import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { GetMultiGoodsResponse } from './api-services/get-multi-goods.service';
import { GetCandidateGoodsResponse } from './api-services/get-candidate-goods.service';
import { GetMultiCodeInfoRespose } from './api-services/get-multi-code-info.service';
import { RegistMultiGoodsResponse } from './api-services/regist-multi-goods.service';

/**
 * マルチ商品設定画面の値を管理するクラス
 *
 * @export KYMW4701Model
 * @class KYMW4701Model
 */
export class KYMW4701Model {
  // 呼び出し元 連携値
  public paramMultiCode = '';
  public paramPcode = '';

  // 画面表示データ
  public multiCode = String(''); // マルチコード
  public commonCatchcopy = String(''); // 共通キャッチコピー
  public commonGoodsExplanation = String(''); // 共通商品説明
  public multiGoodsList: GetMultiGoodsResponse['MultiGoodsList'] = [];
  public candidateGoodsList: GetCandidateGoodsResponse['CandidateGoodsList'] =
    [];
  public searchingGoodsName = '';

  // 差分チェック用
  public commonCatchcopyOrigin = '';
  public commonGoodsExplanationOrigin = '';

  /**
   * 初回起動時の画面反映(マルチ商品一覧)
   */
  public setMultiGoodsData(
    serverData: GetMultiGoodsResponse | RegistMultiGoodsResponse
  ): void {
    // データ初期化
    this.multiCode = '';
    this.commonCatchcopy = '';
    this.commonGoodsExplanation = '';
    this.multiGoodsList = [];

    if (serverData.MultiGoodsList.every(_ => !_.MultiCode)) {
      this.searchingGoodsName = serverData.MultiGoodsList[0].GuideGoodsName;
    } else {
      this.multiGoodsList = serverData.MultiGoodsList;
      this.multiCode = this.multiGoodsList[0].MultiCode;
      this.commonCatchcopy = this.multiGoodsList[0].CommonCatchcopy;
      this.commonGoodsExplanation =
        this.multiGoodsList[0].CommonGoodsExplanation;
      this.searchingGoodsName = this.multiGoodsList.find(
        _ => '1' === _.PublishSeq
      )?.GuideGoodsName;
      if (this.multiGoodsList.length > 0) {
        // 本登録日時を「YYYY年MM月DD日」の書式に変換
        for (let i = 0; i < this.multiGoodsList.length; i++) {
          this.multiGoodsList[i].RegistDate =
            this.multiGoodsList[i].RegistDate == ''
              ? ''
              : PlessViewUtilsSub.editDate(
                  this.multiGoodsList[i].RegistDate,
                  '3'
                );
        }
      }
    }
  }

  /**
   * 初回起動時の画面反映(候補商品一覧)
   */
  public setCandidateGoodsData(serverData: GetCandidateGoodsResponse): void {
    this.candidateGoodsList = serverData.CandidateGoodsList;

    if (this.candidateGoodsList.length > 0) {
      // 本登録日時を「YYYY年MM月DD日」の書式に変換
      for (let i = 0; i < this.candidateGoodsList.length; i++) {
        this.candidateGoodsList[i].RegistDate =
          this.candidateGoodsList[i].RegistDate == ''
            ? ''
            : PlessViewUtilsSub.editDate(
                this.candidateGoodsList[i].RegistDate,
                '3'
              );
      }
    }
  }

  /**
   * 追加ボタン押下時の結果を設定
   */
  public setMultiCodeInfoData(serverData: GetMultiCodeInfoRespose): void {
    // 取得データを「マルチコード」「共通キャッチコピー」「共通商品説明」に格納し再描画する
    this.multiCode = serverData.MultiCode;
    this.commonCatchcopy = serverData.CommonCatchcopy;
    this.commonGoodsExplanation = serverData.CommonGoodsExplanation;
  }

  get hasDiff() {
    return (
      this.commonCatchcopyOrigin !== this.commonCatchcopy ||
      this.commonGoodsExplanationOrigin !== this.commonGoodsExplanation
    );
  }
}
